export default "public/favicon.svg";